export default "__VITE_ASSET__eZhiaRXr__"